"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./RadioColor.css");
var accessibility_1 = require("../../../../../utils/accessibility");
var RadioColor = /** @class */ (function (_super) {
    __extends(RadioColor, _super);
    function RadioColor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }
    RadioColor.prototype.handleKeyPress = function (e) {
        if ((this.props.data.disabled === undefined || this.props.data.disabled === false) &&
            (e.key === 'Enter' || e.charCode === 13)) {
            this.props.events.onKeyPress(this.props.data.value);
        }
    };
    RadioColor.prototype.showCheckmark = function () {
        if (this.props.selected && this.props.data.showCheckmark) {
            return styles.checkmark;
        }
    };
    RadioColor.prototype.getCheckmarkColor = function (props) {
        if (props.data
            && props.data.checkmarkColor) {
            return props.data.checkmarkColor;
        }
        else {
            return 'black';
        }
    };
    RadioColor.prototype.render = function () {
        var labelClasses = this.props.data.disabled ?
            [styles.radioColorItem, styles.disabled, this.props.options.className].join(' ') :
            [styles.radioColorItem, this.props.options.className].join(' ');
        return (React.createElement("label", __assign({ "data-test-id": this.props.testId, className: labelClasses, onKeyPress: this.handleKeyPress }, (this.props.options) ? accessibility_1.getAccessibilityAttributes(this.props.options) : {}),
            this.renderAccessibilityElement(),
            React.createElement("input", { className: styles.radioColorInput, type: "radio", name: this.props.name, checked: this.props.selected, onChange: this.props.events.onChange, value: this.props.data.value, disabled: this.props.data.disabled }),
            React.createElement("div", { style: { backgroundColor: this.props.data.color, color: this.getCheckmarkColor(this.props) }, className: [this.getRadioColorCircleClass(), this.showCheckmark()].join(' ') })));
    };
    RadioColor.prototype.renderAccessibilityElement = function () {
        /* istanbul ignore next */
        if (this.props.options && this.props.options.accessibility) {
            return (React.createElement("div", __assign({ className: styles.hiddenSpoken, dangerouslySetInnerHTML: { __html: this.props.options.accessibility } }, (this.props.options && this.props.options.arialabelledby)
                ? { id: this.props.options.arialabelledby } : {})));
        }
    };
    RadioColor.prototype.getRadioColorCircleClass = function () {
        return [
            styles.radioColorCircle,
            this.props.data.strike === true ? styles.strike : undefined,
        ].join(' ');
    };
    return RadioColor;
}(React.Component));
exports.default = RadioColor;
//# sourceMappingURL=RadioColor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioColor/RadioColor.js
// module id = 1229
// module chunks = 8